module.exports = __webpack_public_path__ + "assets/coffee-code-28ea0211184623b50cdd26c12197be7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/Home/assets/coffee-code.jpg
// module id = 635
// module chunks = 0 1